
import React, { useState } from 'react';
import './DivisionsOverview.css';
// import PricingTable from "../pages/PricingTable"
import { Link } from 'react-router-dom';
import { FaCloud } from 'react-icons/fa';
import { FiCode} from 'react-icons/fi';

const divisions = [

  {
    title: 'Software Development',
    desc: 'Scalable software applications built to enhance productivity, performance, and business growth',
    icon: < FiCode size={40} color='#C77DFF'/>,
   // link: '/pricingTable',
  },

    {
    title: 'Digital Marketing',
    desc: 'Boost your online presence with SEO, social media marketing, and targeted campaigns.',
    icon: '📈',
    link: ''
  },

  {
    title: 'Cloud Solution',
    desc: 'Secure and scalable cloud solutions forstorage, deployment, and business operations.',
    icon: <FaCloud size={40} color='#6EC1E4'/>,
    link: ''
  },

   {
    title: 'Artificial Intelligence',
    desc: 'AI-powered solutions that automate tasks,analyze data, and drive smarter decisions.',
    icon: '🤖',
    link: ''
  },

 
 
];

function DivisionsOverview() {
  const [showAll] = useState(false);
  const displayedDivisions = showAll ? divisions : divisions.slice(0, 7);

  return (
    <section className="divisions-section" id="services">
     
      <div className="divisions-grid">
        {displayedDivisions.map(({ title, desc, icon, link }, idx) => (
          <Link
            to={link || '#'}
            key={idx}
            className="division-card"
            tabIndex="0"
          >
            <div className="division-icon">{icon}</div>
            <h3>{title}</h3>
            <p>{desc}</p>
            <div className="learn-more">Learn More →</div>
          </Link>
        ))}
      </div>

      
    </section>
  );
}

export default DivisionsOverview;